<template>
    <div :class="['contact-block', 'joinus-block']">
        <div class="gabarit">
            <div class="head">
                <div class="head-sizer">
                    <h2 v-html="layout.title"></h2>
                </div>
            </div>
            <div class="sizer">
                <div class="head-sizer dark">
                    <h2 v-html="layout.title"></h2>
                </div>
                <div class="container followup">
                    <p>{{layout.top.description}}</p>
                    <Cta
                        :colors="{ hover: { background: '#114991' } }"
                        :cta="layout.top.cta"
                        class="link"
                    />
                </div>
                <div class="container">
                    <p>{{layout.bottom.description}}</p>
                    <Cta
                        :colors="{ hover: { background: '#114991' } }"
                        :cta="layout.bottom.cta"
                        class="link"
                    />
                </div>
            </div>
        </div>
        <div class="decoration">
            <img :src="layout.image.url" :alt="layout.image.alt"/>
        </div>
    </div>
</template>

<script>
import Cta from '@/components/FlexibleCta'
export default {
    components: {
        Cta
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.contact-block
    @media print
        margin-top: 1.2cm
        margin-bottom: 1.2cm
.decoration
    margin-top: -15%
    @media print
        margin-top: 0
    img
        display: block
        width: 100%
        margin-left: auto
.container
.gabarit
    position: relative
    z-index: 1
    color: #ffffff
    display: flex
.sizer
    flex: 1
    width: 50%
    background-color: #ff2b2a
    overflow: hidden
    position: relative
    padding-top: 8.125%
    padding-bottom: 10%
    @media print
        padding-top: 0
        padding-bottom: 0
.head
    flex: 1
    width: 50%
    overflow: hidden
    padding-top: 8.125%
    @include media-breakpoint-down($lg)
        display: none
.container
    padding-left: 28%
    padding-right: 24%
    &.followup
        margin-top: 240px
        @include media-breakpoint-down($lg)
            margin-top: 9.6%
        @media print
            margin-top: .6cm
    @include media-breakpoint-down($lg)
        padding-left: 9.6%
        padding-right: 9.6%
    &+.container
        padding-top: 8.125%
        @media print
            padding-top: .6cm

.head-sizer
    padding-left: 17.25%
    box-sizing: content-box
    width: 170%
    &.dark
        position: absolute
        left: -100%
        @include media-breakpoint-down($lg)
            position: static
            left: initial
            margin-left: 9.6%
            margin-right: 9.6%
            padding-left: 0%
            width: auto
        h2
            color: #ffffff
h2
    font-size: 160px
    font-weight: 500
    color: #ff2b2a
    white-space: nowrap
    letter-spacing: -0.03125em
    @include media-breakpoint-down($lg)
        font-size: 100px
    @include media-breakpoint-down($md)
        font-size: 86px
    @include media-breakpoint-down($sm)
        font-size: 50px
p
    font-size: 28px
    line-height: 1.6071428571
    margin-top: 1em
    @include media-breakpoint-down($sm)
        font-size: 17px

    @media print
        margin-top: .6cm
.cta
    margin-top: 12%
    @media print
        margin-top: .6cm

a.cta
    @media print
        position: relative
        overflow: visible
        border: none
        &:after
            content:  attr(href)
            font-size: 12px
            font-weight: normal
</style>
